import packageJson from '../../../package.json';


const Index = () => {
    return (
        <footer>
            {`v${packageJson.version}`}
        </footer>
    );
};

export default Index;
